import { useState } from 'react'
import TributacaoEmpresa from './pages/TributacaoEmpresa'
import ParametrosLegais from './pages/ParametrosLegais'
import Ferias from './etapa2/pages/Ferias'
import DecimoTerceiro from './etapa2/pages/DecimoTerceiro'
import Rescisao from './etapa2/pages/Rescisao'
import Beneficios from './etapa3/pages/Beneficios'
import Planos from './etapa3/pages/Planos'
import ESocial from './etapa3/pages/ESocial'
import Funcionarios from './etapa5/pages/Funcionarios'
import RescisaoOutrosTipos from './etapa5/pages/RescisaoOutrosTipos'
import FolhaMensal from './etapa6/pages/FolhaMensal'
import Jornada from './etapa6/pages/Jornada'
import Afastamentos from './etapa6/pages/Afastamentos'
import ViradaAno from './etapa6/pages/ViradaAno'
import './styles.css'
import './etapa2/etapa2.css'
import './etapa3/etapa3.css'
import './etapa6/etapa6.css'

const ABAS = [
  ['tributacao', 'Tributação da empresa', TributacaoEmpresa],
  ['funcionarios', 'Cadastro complementar', Funcionarios],
  ['jornada', 'Jornada e escala', Jornada],
  ['afastamentos', 'Afastamentos e licenças', Afastamentos],
  ['folha', 'Folha mensal', FolhaMensal],
  ['ferias', 'Férias', Ferias],
  ['decimo', '13º salário', DecimoTerceiro],
  ['rescisao', 'Rescisão', Rescisao],
  ['rescisao5', 'Outras rescisões', RescisaoOutrosTipos],
  ['beneficios', 'Benefícios', Beneficios],
  ['planos', 'Planos de saúde', Planos],
  ['esocial', 'eSocial', ESocial],
  ['virada', 'Virada do ano', ViradaAno],
  ['parametros', 'Parâmetros legais', ParametrosLegais],
]

// Etapas 1 a 6. Uso no sistema principal: <FolhaModuleEtapa6 empresaId={idDaEmpresaLogada} />
export default function FolhaModuleEtapa6({ empresaId }) {
  const [aba, setAba] = useState('tributacao')
  const Pagina = ABAS.find((a) => a[0] === aba)[2]
  return (
    <div className="folha-modulo">
      <nav>
        {ABAS.map(([id, nome]) => (
          <button key={id} className={aba === id ? 'ativa' : ''} onClick={() => setAba(id)}>{nome}</button>
        ))}
      </nav>
      <Pagina empresaId={empresaId} />
    </div>
  )
}
